
import { useState, useEffect } from 'react';
import { useNodesState, useEdgesState } from '@xyflow/react';
import { WorkflowNode, WorkflowEdge } from '../components/workflow/types';

export function useWorkflowAnimation(initialNodes: WorkflowNode[], initialEdges: WorkflowEdge[]) {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [activeStep, setActiveStep] = useState(0);

  // Animation effect to gradually reveal nodes
  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeStep < initialNodes.length - 1) {
        setActiveStep(activeStep + 1);
      } else {
        // Reset animation after a pause
        setTimeout(() => setActiveStep(0), 5000);
      }
    }, 1200);

    return () => clearTimeout(timer);
  }, [activeStep, initialNodes.length]);

  // Update node states for animation
  useEffect(() => {
    setNodes((nds) =>
      nds.map((node, index) => ({
        ...node,
        style: {
          opacity: index <= activeStep ? 1 : 0.3,
          transition: 'all 0.5s ease-in-out'
        }
      }))
    );

    setEdges((eds) =>
      eds.map((edge, index) => ({
        ...edge,
        style: {
          ...(edge.style || {}),
          stroke: index <= activeStep - 1 ? '#3B82F6' : '#ddd',
          opacity: index <= activeStep - 1 ? 1 : 0.3,
          transition: 'all 0.5s ease-in-out'
        },
        animated: index <= activeStep - 1
      }))
    );
  }, [activeStep, setNodes, setEdges]);

  return {
    nodes,
    edges,
    onNodesChange,
    onEdgesChange,
    setNodes,
    setEdges
  };
}
